
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_25567","data-name":"Group 25567","xmlns":"http://www.w3.org/2000/svg","width":"10.856","height":"7.365"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_25560","data-name":"Group 25560"}},[_c('g',{attrs:{"id":"Group_25561","data-name":"Group 25561","fill":"#fff"}},[_c('path',{attrs:{"id":"Path_20291","data-name":"Path 20291","d":"M10.838 8.441a.55.55 0 000-.113c-.012-.059-.345-1.438-2.629-1.438a3.94 3.94 0 00-.68.043 6.31 6.31 0 00-.609.138 5.524 5.524 0 00-2.757-.65H4.1C1.3 6.429.4 7.662.144 8.208a.585.585 0 00-.059.116h.008l-.008.021a.58.58 0 00.494.883h9.7c.309 0 .564-.366.578-.674a.575.575 0 00-.017-.115","transform":"translate(0 -1.865)"}}),_c('path',{attrs:{"id":"Path_20292","data-name":"Path 20292","d":"M4.7 4.554a2.275 2.275 0 10-.549-.054 2.233 2.233 0 00.488.056","transform":"translate(-.543)"}}),_c('path',{attrs:{"id":"Path_20293","data-name":"Path 20293","d":"M10.193 5.578a1.57 1.57 0 00-.033-3.14 1.572 1.572 0 00-1.572 1.57v.005a1.572 1.572 0 001.542 1.566","transform":"translate(-1.955 -.555)"}})])])])
          )
        }
      }
    